// Module
var code = "<handling-fees></handling-fees>\n";
// Exports
module.exports = code;